import { BLOCKS, Text } from '@contentful/rich-text-types'
import RichTextType from 'models/types/ts/richTextType'

/**
 * Creates a simple RichText document with a single paragraph from a plain text string
 * Used for providing default translations when Contentful content is not available
 *
 * This function efficiently creates a minimal RichText object with just the required structure
 */
export const generateDefaultMessage = (text: string): RichTextType => ({
    json: {
        nodeType: BLOCKS.DOCUMENT,
        data: {},
        content: [
            {
                nodeType: BLOCKS.PARAGRAPH,
                data: {},
                content: [
                    {
                        nodeType: 'text',
                        value: text,
                        marks: [],
                        data: {},
                    } as Text,
                ],
            },
        ],
    },
    links: {
        assets: {
            block: [],
            hyperlink: [],
        },
        entries: {
            block: [],
            inline: [],
            hyperlink: [],
        },
    },
})
